import { Controller, useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import dayjs from 'dayjs';
import styled from '@emotion/styled';
import DatePicker from 'react-datepicker';
import SvgImage from '@/components/Module/SvgImage';
import { useTranslation } from 'react-i18next';

const CustomDatePicker = () => {
  const { t } = useTranslation();
  const { control, watch, setValue } = useFormContext<RecordFilter>();

  return (
    <Wrapper>
      <Controller
        name="meetingDate"
        control={control}
        render={({ field }) => (
          <StyledDatePicker
            selected={field.value ? dayjs(field.value).toDate() : null}
            onChange={(date: Date | null) => {
              return field.onChange(date ? dayjs(date) : '');
            }}
            autoFocus={true}
            showTimeSelect
            timeIntervals={5}
            timeCaption={t('회의 시간')}
            dateFormat="yyyy-MM-dd hh:mm aa"
            placeholderText="yyyy-MM-dd hh:mm aa"
            popperPlacement="bottom-end"
            isClearable={false}
          />
        )}
      />
      {watch('meetingDate') && (
        <button
          style={{ position: 'absolute', right: '14px', top: '16px' }}
          onClick={() => setValue('meetingDate', null)}
        >
          <SvgImage name={'x'} />
        </button>
      )}
    </Wrapper>
  );
};

export default CustomDatePicker;

const Wrapper = styled.div`
  position: relative;
  .react-datepicker-wrapper {
    width: 100%;
  }
`;

const StyledDatePicker = styled(DatePicker as any)`
  width: 100%;
  padding: 16px 16px 16px 12px;
  font-size: 14px;
  font-weight: 4000;
  box-shadow: 0 0 4px 0 rgba(0, 102, 204, 0.25);
  border-radius: 6px;
  border: 1px solid black;
  :focus {
    outline: none;
  }
  ::placeholder {
    color: var(--dk-text-dim, #bbb);
  }
`;
